import React, { useMemo, useState } from "react";

import TemarioDiplomaturaMedicinaAdicciones from "../assets/temarios/TemarioDiplomaturaMedicinaAdicciones";
import TemarioDiplomaturaCuidadosPediatricosRespiratorios from "../assets/temarios/TemarioDiplomaturaCuidadosPediatricosRespiratorios";
import TemarioDiplomaturaNutricionDiabetes from "../assets/temarios/TemarioDiplomaturaNutricionDiabetes";
import TemarioCursoOperadorPrehospitalarioEmergencias from "../assets/temarios/TemarioCursoOperadorPrehospitalarioEmergencias";
import TemarioProgramaInmunizaciones from "../assets/temarios/TemarioProgramaInmunizaciones";
import TemarioCursoRCP from "../assets/temarios/TemarioCursoRCP";
import TemarioDiplomaturaIAMedica from "../assets/temarios/TemarioDiplomaturaIAMedica";
import TemarioDiplomaturaInnovacionDigital from "../assets/temarios/TemarioDiplomaturaInnovacionDigital";
import TemarioDiplomaturaBioremodelacionFacial from "../assets/temarios/TemarioDiplomaturaBioremodelacionFacial";
import TemarioPosgradoNutricionClinica from "../assets/temarios/TemarioPosgradoNutricionClinica";
import TemarioPosgradoNutricionMicrobiota from "../assets/temarios/TemarioPosgradoNutricionMicrobiota";
import TemarioPosgradoDermatologiaEsteticaTerapeutica from "../assets/temarios/TemarioPosgradoDermatologiaEsteticaTerapeutica";
import TemarioPosgradoGestionAdministracionEnfermeria from "../assets/temarios/TemarioPosgradoGestionAdministracionEnfermeria";
import TemarioPosgradoPsiquiatriaClinica from "../assets/temarios/TemarioPosgradoPsiquiatriaClinica";
import TemarioPosgradoMedicinaPrecisionGenomica from "../assets/temarios/TemarioPosgradoMedicinaPrecisionGenomica";
import TemarioDiplomaturaGestionTelemedicina from "../assets/temarios/TemarioDiplomaturaGestionTelemedicina";
import TemarioDiplomaturaNutricionMicrobiota from "../assets/temarios/TemarioDiplomaturaNutricionMicrobiota";
import TemarioDiplomaturaNutricionPlantBased from "../assets/temarios/TemarioDiplomaturaNutricionPlantBased";
import TemarioPosgradoEnfermeriaOncologica from "../assets/temarios/TemarioPosgradoEnfermeriaOncologica";
import TemarioDiplomaturaEnfermeriaConsumosProblematicos from "../assets/temarios/TemarioDiplomaturaEnfermeriaConsumosProblematicos";
import TemarioDiplomaturaSkincare from "../assets/temarios/TemarioDiplomaturaSkincare";
import TemarioPosgradoToxicologia from "../assets/temarios/TemarioPosgradoToxicologia";
import TemarioDiplomaturaNutricionDeportiva from "../assets/temarios/TemarioDiplomaturaNutricionDeportiva";
import TemarioDiplomaturaEnfermeriaNeurologica from "../assets/temarios/TemarioDiplomaturaEnfermeriaNeurologica";
import TemarioDiplomaturaMarketingMedico from "../assets/temarios/TemarioDiplomaturaMarketingMedico";
import TemarioDiplomaturaMedicinaLaboral from "../assets/temarios/TemarioDiplomaturaMedicinaLaboral";
import TemarioDiplomaturaMicrotrasplanteCapilar from "../assets/temarios/TemarioDiplomaturaMicrotrasplanteCapilar";
import TemarioDiplomaturaUrgenciasNeurocardiologicas from "../assets/temarios/TemarioDiplomaturaUrgenciasNeurocardiologicas";
import TemarioDiplomaturaCriminalisticaCienciasForenses from "../assets/temarios/TemarioDiplomaturaCriminalisticaCienciasForenses";
import TemarioDiplomaturaEnfermeriaCuidadosPaliativos from "../assets/temarios/TemarioDiplomaturaEnfermeriaCuidadosPaliativos";
import TemarioDiplomaturaGinecologiaRegenerativaEsteticaFuncional from "../assets/temarios/TemarioDiplomaturaGinecologiaRegenerativaEsteticaFuncional";
import TemarioPosgradoBigDataIASalud from "../assets/temarios/TemarioPosgradoBigDataIASalud";
import TemarioPosgradoGestionDeEstablecimientosSistemasDeSaludDigital from "../assets/temarios/TemarioPosgradoGestionDeEstablecimientosSistemasDeSaludDigital";
import TemarioPosgradoInvestigacionClinica from "../assets/temarios/TemarioPosgradoInvestigacionClinica";

const utf8Decoder = new TextDecoder("utf-8");

const TEMARIO_COMPONENTS = [
    null,
    TemarioDiplomaturaUrgenciasNeurocardiologicas,
    TemarioDiplomaturaBioremodelacionFacial,
    TemarioDiplomaturaMedicinaAdicciones,
    TemarioDiplomaturaNutricionDeportiva,
    TemarioDiplomaturaNutricionPlantBased,
    TemarioDiplomaturaNutricionDiabetes,
    TemarioDiplomaturaNutricionMicrobiota,
    TemarioDiplomaturaEnfermeriaNeurologica,
    TemarioPosgradoEnfermeriaOncologica,
    TemarioDiplomaturaEnfermeriaConsumosProblematicos,
    TemarioDiplomaturaCuidadosPediatricosRespiratorios,
    TemarioDiplomaturaEnfermeriaCuidadosPaliativos,
    TemarioDiplomaturaIAMedica,
    TemarioDiplomaturaInnovacionDigital,
    TemarioDiplomaturaGestionTelemedicina,
    TemarioDiplomaturaGinecologiaRegenerativaEsteticaFuncional,
    TemarioDiplomaturaMarketingMedico,
    TemarioDiplomaturaCriminalisticaCienciasForenses,
    TemarioPosgradoDermatologiaEsteticaTerapeutica,
    TemarioPosgradoGestionAdministracionEnfermeria,
    TemarioPosgradoPsiquiatriaClinica,
    TemarioPosgradoMedicinaPrecisionGenomica,
    TemarioPosgradoToxicologia,
    TemarioPosgradoNutricionMicrobiota,
    TemarioPosgradoNutricionClinica,
    TemarioPosgradoBigDataIASalud,
    TemarioPosgradoGestionDeEstablecimientosSistemasDeSaludDigital,
    TemarioDiplomaturaSkincare,
    TemarioCursoOperadorPrehospitalarioEmergencias,
    TemarioProgramaInmunizaciones,
    TemarioCursoRCP,
    TemarioDiplomaturaMedicinaLaboral,
    TemarioDiplomaturaMicrotrasplanteCapilar,
    TemarioPosgradoInvestigacionClinica,
];

const TEMARIO_COMPONENTS_BY_COURSE_ID = {
    101: TemarioDiplomaturaUrgenciasNeurocardiologicas,
    102: TemarioDiplomaturaBioremodelacionFacial,
    103: TemarioDiplomaturaMedicinaAdicciones,
    111: TemarioDiplomaturaNutricionDeportiva,
    112: TemarioDiplomaturaNutricionPlantBased,
    113: TemarioDiplomaturaNutricionDiabetes,
    114: TemarioDiplomaturaNutricionMicrobiota,
    121: TemarioDiplomaturaEnfermeriaNeurologica,
    122: TemarioPosgradoEnfermeriaOncologica,
    123: TemarioDiplomaturaEnfermeriaConsumosProblematicos,
    124: TemarioDiplomaturaCuidadosPediatricosRespiratorios,
    125: TemarioDiplomaturaEnfermeriaCuidadosPaliativos,
    131: TemarioDiplomaturaIAMedica,
    132: TemarioDiplomaturaInnovacionDigital,
    133: TemarioDiplomaturaGestionTelemedicina,
    151: TemarioDiplomaturaGinecologiaRegenerativaEsteticaFuncional,
    141: TemarioDiplomaturaMedicinaLaboral,
    161: TemarioDiplomaturaMarketingMedico,
    171: TemarioDiplomaturaCriminalisticaCienciasForenses,
    204: TemarioPosgradoDermatologiaEsteticaTerapeutica,
    205: TemarioPosgradoGestionAdministracionEnfermeria,
    206: TemarioPosgradoPsiquiatriaClinica,
    207: TemarioPosgradoMedicinaPrecisionGenomica,
    208: TemarioPosgradoToxicologia,
    214: TemarioPosgradoNutricionMicrobiota,
    215: TemarioPosgradoNutricionClinica,
    234: TemarioPosgradoBigDataIASalud,
    235: TemarioPosgradoGestionDeEstablecimientosSistemasDeSaludDigital,
    236: TemarioPosgradoInvestigacionClinica,
    309: TemarioDiplomaturaSkincare,
    341: TemarioCursoOperadorPrehospitalarioEmergencias,
    342: TemarioProgramaInmunizaciones,
    343: TemarioCursoRCP,
    142: TemarioDiplomaturaMicrotrasplanteCapilar,
};

function resolveCourseTemarioComponent(course) {
    if (!course?.id) {
        return null;
    }

    return TEMARIO_COMPONENTS_BY_COURSE_ID[course.id] || null;
}

function normalizeTemarioText(value) {
    if (typeof value !== "string" || !/[ÃÂâ]/.test(value)) {
        return value || "";
    }

    let nextValue = value;

    for (let index = 0; index < 2; index += 1) {
        if (!/[ÃÂâ]/.test(nextValue)) {
            break;
        }

        try {
            nextValue = utf8Decoder.decode(
                Uint8Array.from(nextValue, (character) => character.charCodeAt(0))
            );
        } catch {
            break;
        }
    }

    return nextValue;
}

function cleanText(value) {
    return normalizeTemarioText(String(value || ""))
        .replace(/\u00a0/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}

function splitTemarioItems(value) {
    const cleanValue = cleanText(value)
        .replace(/[●•]/g, " |SPLIT| ")
        .replace(/\s+-\s+/g, " |SPLIT| ")
        .replace(/\s+–\s+/g, " |SPLIT| ")
        .replace(/\s+(?=\d+\.\s+[A-ZÁÉÍÓÚÑ¿])/gu, " |SPLIT| ");

    return cleanValue
        .split(/\s*\|SPLIT\|\s*/)
        .flatMap((item) => {
            if (item.length <= 140) {
                return [item];
            }

            const sentences = item
                .split(/\.\s+(?=[A-ZÁÉÍÓÚÑ¿])/u)
                .filter(Boolean);

            return sentences.length > 1 ? sentences : [item];
        })
        .map((item) =>
            item
                .replace(/^[●•\-–]+\s*/g, "")
                .replace(/\s*[:：]\s*$/g, "")
                .replace(/\s+/g, " ")
                .trim()
        )
        .filter(Boolean);
}

function extractTextContent(node) {
    if (typeof node === "string" || typeof node === "number") {
        return cleanText(node);
    }

    if (!React.isValidElement(node)) {
        return "";
    }

    return React.Children.toArray(node.props.children)
        .map(extractTextContent)
        .filter(Boolean)
        .join(" ")
        .replace(/\s+/g, " ")
        .trim();
}

function getSectionTitleParts(title, fallbackIndex) {
    const cleanTitle = cleanText(title);
    const namedMatch = cleanTitle.match(
        /^(?:unidad|clase|encuentro|m[oó]dulo|modulo)\s*(\d+)\s*[:.\-–]?\s*(.*)$/i
    );

    if (namedMatch) {
        return {
            number: namedMatch[1].padStart(2, "0"),
            label: namedMatch[2] || cleanTitle,
        };
    }

    const numericMatch = cleanTitle.match(/^(\d+)\.?\s*(.*)$/);

    if (numericMatch) {
        return {
            number: numericMatch[1].padStart(2, "0"),
            label: numericMatch[2] || cleanTitle,
        };
    }

    return {
        number: String(fallbackIndex + 1).padStart(2, "0"),
        label: cleanTitle,
    };
}

function buildTemarioSections(renderedTemario) {
    if (!React.isValidElement(renderedTemario)) {
        return [];
    }

    const rootChildren = React.Children.toArray(renderedTemario.props.children);
    const sections = [];
    let currentSection = null;
    let currentModule = "";

    const pushCurrentSection = () => {
        if (!currentSection) {
            return;
        }

        if (
            currentSection.title ||
            currentSection.description.length ||
            currentSection.items.length
        ) {
            sections.push(currentSection);
        }

        currentSection = null;
    };

    rootChildren.forEach((node) => {
        if (!React.isValidElement(node)) {
            return;
        }

        const nodeType =
            typeof node.type === "string" ? node.type.toLowerCase() : "";
        const className = String(node.props.className || "");

        if (nodeType === "span" && className.includes("temario-module-heading")) {
            pushCurrentSection();
            currentModule = extractTextContent(node);
            return;
        }

        if (
            nodeType === "b" ||
            nodeType === "strong" ||
            (nodeType === "span" && !className.includes("fw-light"))
        ) {
            const title = extractTextContent(node);

            if (title) {
                pushCurrentSection();
                currentSection = {
                    title,
                    moduleTitle: currentModule,
                    description: [],
                    items: [],
                };
            }

            return;
        }

        if (nodeType === "ul") {
            if (!currentSection) {
                currentSection = {
                    title: "Temario",
                    moduleTitle: currentModule,
                    description: [],
                    items: [],
                };
            }

            currentSection.items.push(
                ...React.Children.toArray(node.props.children)
                    .flatMap((child) =>
                        splitTemarioItems(extractTextContent(child))
                    )
                    .filter(Boolean)
            );

            return;
        }

        if (
            nodeType === "p" ||
            (nodeType === "span" && className.includes("fw-light"))
        ) {
            const description = extractTextContent(node);

            if (description) {
                if (!currentSection) {
                    currentSection = {
                        title: "Temario",
                        moduleTitle: currentModule,
                        description: [],
                        items: [],
                    };
                }

                currentSection.items.push(...splitTemarioItems(description));
            }
        }
    });

    pushCurrentSection();

    return sections;
}

function groupTemarioSections(sections) {
    const hasSourceModules = sections.some((section) => section.moduleTitle);

    if (!hasSourceModules) {
        return [
            {
                title: "",
                sections: sections.map((section, index) => ({ section, index })),
            },
        ];
    }

    if (hasSourceModules) {
        return sections.reduce((groups, section, index) => {
            const title = section.moduleTitle || "Módulo";
            const currentGroup = groups.find((group) => group.title === title);

            if (currentGroup) {
                currentGroup.sections.push({ section, index });
                return groups;
            }

            groups.push({
                title,
                sections: [{ section, index }],
            });

            return groups;
        }, []);
    }

    return [];
}

function collapseLargeModuleTemario(sections) {
    const hasSourceModules = sections.some((section) => section.moduleTitle);

    if (!hasSourceModules || sections.length <= 20) {
        return sections;
    }

    const groups = sections.reduce((nextGroups, section) => {
        const title = section.moduleTitle || "Módulo";
        const currentGroup = nextGroups.find((group) => group.title === title);

        if (currentGroup) {
            currentGroup.sections.push(section);
            return nextGroups;
        }

        nextGroups.push({
            title,
            sections: [section],
        });

        return nextGroups;
    }, []);

    if (groups.length <= 1) {
        return sections;
    }

    return groups.map((group) => ({
        title: group.title,
        moduleTitle: "",
        description: [],
        items: [],
        children: group.sections.map((section) => ({
            title: section.title,
            description: section.description,
            items: section.items,
        })),
    }));
}

export function getTemarioUnitCount(temario, course = null) {
    const TemarioComponent =
        resolveCourseTemarioComponent(course) || TEMARIO_COMPONENTS[temario] || null;

    if (!TemarioComponent) {
        return null;
    }

    const renderedTemario = TemarioComponent({});
    const sections = buildTemarioSections(renderedTemario);
    const displaySections = collapseLargeModuleTemario(sections);

    return displaySections.length || null;
}

function getTemarioHeading(sections, modalidad) {
    const unitsLabel = `${sections.length} ${
        sections.length === 1 ? "unidad" : "unidades"
    }`;
    const modalityText = cleanText(modalidad);

    if (!modalityText) {
        return unitsLabel;
    }

    const normalizedModality = modalityText.toLowerCase().startsWith("modalidad")
        ? modalityText
        : `Modalidad ${modalityText.toLowerCase()}`;

    return `${unitsLabel} · ${normalizedModality}`;
}

function TemarioAccordion({ sections, modalidad, headingOverride = "" }) {
    const [activeIndex, setActiveIndex] = useState(null);
    const displaySections = useMemo(
        () => collapseLargeModuleTemario(sections),
        [sections]
    );
    const sectionGroups = useMemo(
        () => groupTemarioSections(displaySections),
        [displaySections]
    );

    return (
        <div className="temario-layout">
            <span className="section-tag">Plan de estudios</span>
            <h3 className="temario-heading">
                {headingOverride || getTemarioHeading(displaySections, modalidad)}
            </h3>
            <div className="temario-accordion">
                {sectionGroups.map((group) => (
                    <div
                        key={group.title || "unidades"}
                        className="temario-module"
                    >
                        {group.sections.map(({ section, index }) => {
                            const titleParts = getSectionTitleParts(section.title, index);
                            const unitNumber =
                                Number.parseInt(titleParts.number, 10) || index + 1;
                            const isOpen = activeIndex === index;

                            return (
                                <div
                                    key={`${titleParts.number}-${titleParts.label}-${index}`}
                                    className={`temario-item${isOpen ? " is-open" : ""}`}
                                >
                                    <button
                                        type="button"
                                        className="temario-summary"
                                        aria-expanded={isOpen}
                                        onClick={() =>
                                            setActiveIndex(isOpen ? null : index)
                                        }
                                    >
                                        <span className="temario-summary-number">
                                            {titleParts.number}
                                        </span>
                                        <span className="temario-summary-title">
                                            {titleParts.label}
                                        </span>
                                        <span className="temario-summary-kicker">
                                            Unidad {unitNumber}
                                        </span>
                                    </button>
                                    <div className="temario-body">
                                        {section.description.map((paragraph) => (
                                            <p
                                                key={`${titleParts.number}-${paragraph}`}
                                                className="temario-description"
                                            >
                                                {paragraph}
                                            </p>
                                        ))}
                                        {section.items.length ? (
                                            <ul className="temario-list">
                                                {section.items.map((item) => (
                                                    <li
                                                        key={`${titleParts.number}-${item}`}
                                                        className="temario-list-item"
                                                    >
                                                        {item}
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : null}
                                        {section.children?.length ? (
                                            <div className="temario-subunits">
                                                {section.children.map((child, childIndex) => (
                                                    <div
                                                        key={`${titleParts.number}-${child.title}-${childIndex}`}
                                                        className="temario-subunit"
                                                    >
                                                        <h5 className="temario-subunit-title">
                                                            {child.title}
                                                        </h5>
                                                        {child.description.map((paragraph) => (
                                                            <p
                                                                key={`${child.title}-${paragraph}`}
                                                                className="temario-description"
                                                            >
                                                                {paragraph}
                                                            </p>
                                                        ))}
                                                        {child.items.length ? (
                                                            <ul className="temario-list">
                                                                {child.items.map((item) => (
                                                                    <li
                                                                        key={`${child.title}-${item}`}
                                                                        className="temario-list-item"
                                                                    >
                                                                        {item}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        ) : null}
                                                    </div>
                                                ))}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default function Temarios({ temario, modalidad, course = null }) {
    const TemarioComponent =
        resolveCourseTemarioComponent(course) || TEMARIO_COMPONENTS[temario] || null;

    const renderedTemario = useMemo(() => {
        if (!TemarioComponent) {
            return null;
        }

        return TemarioComponent({});
    }, [TemarioComponent]);

    const sections = useMemo(
        () => buildTemarioSections(renderedTemario),
        [renderedTemario]
    );

    if (!TemarioComponent) {
        return (
            <div className="temario-empty">
                El temario estará disponible próximamente.
            </div>
        );
    }

    if (!sections.length) {
        return renderedTemario;
    }

    return (
        <TemarioAccordion
            sections={sections}
            modalidad={modalidad}
            headingOverride={cleanText(course?.pageContent?.temarioHeading)}
        />
    );
}
